/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/fragments-delivery-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/fragments-delivery-api-client";
import type { FragmentsDeliveryAPIStationConfigClientGetConfigQueryResponse, FragmentsDeliveryAPIStationConfigClientGetConfigPathParams } from "../models/FragmentsDeliveryAPIStationConfigClientGetConfig";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { fragmentsDeliveryAPIStationConfigClientGetConfig } from "../axios/fragmentsDeliveryAPIStationConfigClientGetConfig";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const fragmentsDeliveryAPIStationConfigClientGetConfigQueryKey = (stationId: FragmentsDeliveryAPIStationConfigClientGetConfigPathParams["stationId"]) => ["fragments-delivery-api", { url: '/station-config/:stationId', params: {stationId:stationId} }] as const

export type FragmentsDeliveryAPIStationConfigClientGetConfigQueryKey = ReturnType<typeof fragmentsDeliveryAPIStationConfigClientGetConfigQueryKey>

export function fragmentsDeliveryAPIStationConfigClientGetConfigQueryOptions(stationId: FragmentsDeliveryAPIStationConfigClientGetConfigPathParams["stationId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = fragmentsDeliveryAPIStationConfigClientGetConfigQueryKey(stationId)
  return queryOptions<FragmentsDeliveryAPIStationConfigClientGetConfigQueryResponse, ResponseErrorConfig<Error>, FragmentsDeliveryAPIStationConfigClientGetConfigQueryResponse, typeof queryKey>({
   enabled: !!(stationId),
   queryKey,
   queryFn: async ({ signal }) => {
      config.signal = signal
      return fragmentsDeliveryAPIStationConfigClientGetConfig(stationId, config)
   },
  })
}

/**
 * @summary Get Station config (client access)
 * {@link /station-config/:stationId}
 */
export function useFragmentsDeliveryAPIStationConfigClientGetConfig<TData = FragmentsDeliveryAPIStationConfigClientGetConfigQueryResponse, TQueryData = FragmentsDeliveryAPIStationConfigClientGetConfigQueryResponse, TQueryKey extends QueryKey = FragmentsDeliveryAPIStationConfigClientGetConfigQueryKey>(stationId: FragmentsDeliveryAPIStationConfigClientGetConfigPathParams["stationId"], options: 
{
  query?: Partial<QueryObserverOptions<FragmentsDeliveryAPIStationConfigClientGetConfigQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch }
}
 = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? fragmentsDeliveryAPIStationConfigClientGetConfigQueryKey(stationId)

  const query = useQuery({
   ...fragmentsDeliveryAPIStationConfigClientGetConfigQueryOptions(stationId, config),
   queryKey,
   ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}